import { post } from "@/application/api";
import { AxiosResponse } from "axios";

export function logout(): Promise<AxiosResponse<void>> {
  return post("auth/logout");
}
